<template>
  <div class="wrapper">
    <!-- 带有快捷方式 -->
    <template v-if="shortcutsFlag && !shortcutsT1Flag">
      <byted-range-picker
        v-model="time"
        format="YYYY-MM-DD"
        value-format="YYYY-MM-DD"
        :shortcuts="shortcutsR"
        editable
        :clearable="clearable"
        :transfer="true"
        :placeholder="['开始日期', '结束日期']"
        @change="emitOpertion"
      >
        <!-- $emit('update:datevalue', time) -->
      </byted-range-picker>
    </template>
    <!-- T+1的时间组件 -->
    <template v-if="shortcutsFlag && shortcutsT1Flag">
      <byted-range-picker
        v-model="time"
        format="YYYY-MM-DD"
        value-format="YYYY-MM-DD"
        :shortcuts="shortcutsRT1"
        editable
        :clearable="clearable"
        :transfer="true"
        :placeholder="['开始日期', '结束日期']"
        @change="emitOpertion"
        :disabledDate="disabledDate"
      >
        <!-- $emit('update:datevalue', time) -->
      </byted-range-picker>
    </template>
    <!-- 无快捷方式 -->
    <template v-if="!shortcutsFlag">
      <byted-range-picker
        v-model="time"
        format="YYYY-MM-DD"
        value-format="YYYY-MM-DD"
        editable
        :clearable="clearable"
        :transfer="true"
        :placeholder="['开始日期', '结束日期']"
        @change="emitOpertion"
      >
        <!-- $emit('update:datevalue', time) -->
      </byted-range-picker>
    </template>
  </div>
</template>

<script>
import moment from "moment";
import dayjs from "dayjs";
export default {
  // props: ['datevalue'],
  props: {
    datevalue: { type: Array }, // 时间值 ['2021-02-01','2021-02-26']
    shortcutsFlag: {
      // 是否显示左侧快捷选择
      type: Boolean,
      default: true,
    },
    // t+1的左边快捷选择
    shortcutsT1Flag: {
      type: Boolean,
      default: false,
    },
    clearFlag: {
      type: Boolean | Number,
      default: true,
    },
  },
  data() {
    return {
      clearable: false,
      time: this.datevalue,
      moment: moment,
      shortcutsR: [
        {
          text: "今天",
          onClick: () => {
            const now = new Date();
            const today = dayjs(now).format("YYYY-MM-DD");
            this.time = [today, today];
            this.emitOpertion();
          },
        },
        {
          text: "昨天",
          onClick: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            const st = dayjs(start).format("YYYY-MM-DD");
            const en = dayjs(start).format("YYYY-MM-DD");
            this.time = [st, en];
            this.emitOpertion();
          },
        },
        {
          text: "近一周",
          onClick: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            const st = dayjs(start).format("YYYY-MM-DD");
            const en = dayjs(end).format("YYYY-MM-DD");
            this.time = [st, en];
            this.emitOpertion();
          },
        },
        {
          text: "近30天",
          onClick: () => {
            const end = new Date();
            const start = moment().subtract(1, "months").format("YYYY-MM-DD");
            const st = dayjs(start).format("YYYY-MM-DD");
            const en = dayjs(end).format("YYYY-MM-DD");
            this.time = [st, en];
            this.emitOpertion();
          },
        },
        {
          text: "近60天",
          onClick: () => {
            const start = moment().subtract(2, "months").format("YYYY-MM-DD");
            const end = moment().format("YYYY-MM-DD");
            this.time = [start, end];
            this.emitOpertion();
          },
        },
        {
          text: "近90天",
          onClick: () => {
            const start = moment().subtract(3, "months").format("YYYY-MM-DD");
            const end = moment().format("YYYY-MM-DD");
            this.time = [start, end];
            this.emitOpertion();
          },
        },
        {
          text: "本月",
          onClick: () => {
            const end = new Date();
            const years = end.getFullYear();
            const mouths = end.getMonth() + 1;
            const start = new Date(years + "-" + mouths + "-01");
            const st = dayjs(start).format("YYYY-MM-DD");
            const en = dayjs(end).format("YYYY-MM-DD");
            this.time = [st, en];
            this.emitOpertion();
          },
        },
        {
          text: "上个月",
          onClick: () => {
            const preMonth = moment().subtract(1, "months").endOf("month");
            const end = preMonth.format("YYYY-MM-DD");
            const start = preMonth.format("YYYY-MM-01");
            const st = dayjs(start).format("YYYY-MM-DD");
            const en = dayjs(end).format("YYYY-MM-DD");
            this.time = [st, en];
            this.emitOpertion();
          },
        },
      ],
      // T+1的特殊选择项
      shortcutsRT1: [
        {
          text: "昨天",
          onClick: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            const st = dayjs(start).subtract(1, "day").format("YYYY-MM-DD");
            const en = dayjs(start).subtract(1, "day").format("YYYY-MM-DD");
            this.time = [st, en];
            this.emitOpertion();
          },
        },
        {
          text: "近一周",
          onClick: () => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            const st = dayjs(start).subtract(1, "day").format("YYYY-MM-DD");
            const en = dayjs(end).subtract(1, "day").format("YYYY-MM-DD");
            this.time = [st, en];
            this.emitOpertion();
          },
        },
        {
          text: "近30天",
          onClick: () => {
            const end = new Date();
            const start = moment().subtract(1, "months").format("YYYY-MM-DD");
            const st = dayjs(start).subtract(1, "day").format("YYYY-MM-DD");
            const en = dayjs(end).subtract(1, "day").format("YYYY-MM-DD");
            this.time = [st, en];
            this.emitOpertion();
          },
        },
        {
          text: "近60天",
          onClick: () => {
            const start = moment()
              .subtract(2, "months")
              .subtract(1, "day")
              .format("YYYY-MM-DD");
            const end = moment().subtract(1, "day").format("YYYY-MM-DD");
            this.time = [start, end];
            this.emitOpertion();
          },
        },
        {
          text: "近90天",
          onClick: () => {
            const start = moment()
              .subtract(3, "months")
              .subtract(1, "day")
              .format("YYYY-MM-DD");
            const end = moment().subtract(1, "day").format("YYYY-MM-DD");
            this.time = [start, end];
            this.emitOpertion();
          },
        },
        {
          text: "本月",
          onClick: () => {
            const end = new Date();
            const years = end.getFullYear();
            const mouths = end.getMonth() + 1;
            const start = new Date(years + "-" + mouths + "-01");
            const st = dayjs(start).format("YYYY-MM-DD");
            const en = dayjs(end).subtract(1, "day").format("YYYY-MM-DD");
            this.time = [st, en];
            this.emitOpertion();
          },
        },
        {
          text: "上个月",
          onClick: () => {
            const preMonth = moment().subtract(1, "months").endOf("month");
            const end = preMonth.format("YYYY-MM-DD");
            const start = preMonth.format("YYYY-MM-01");
            const st = dayjs(start).format("YYYY-MM-DD");
            const en = dayjs(end).format("YYYY-MM-DD");
            this.time = [st, en];
            this.emitOpertion();
          },
        },
      ],
      dayjs: dayjs,
    };
  },
  watch: {
    datevalue: {
      handler: function (newVal, oldVal) {
        this.time = newVal;
      },
      deep: true,
    },
    clearFlag: {
      handler: function (val) {
        this.clearable = Boolean(val);
      },
      immediate: true,
    },
  },
  methods: {
    emitOpertion() {
      this.$emit("update:datevalue", this.time);
      this.$emit("change", this.time);
    },
    disabledDate({ current }) {
      return current && current > moment().subtract(1, "days").endOf("day");
    },
  },
};
</script>

<style scoped>
.wrapper .byted-range-picker {
  line-height: normal !important;
}
.byted-range-picker {
  height: 32px;
}
</style>
